import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import SmallAnlageCard from "../anlage/SmallAnlageCard";
import HoverCard from "../shared/HoverCard";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { MdOutlineSolarPower } from "react-icons/md";
import QuickAccessCard from "../shared/QuickAccessCard";
import EnergoTab from "../shared/EnergoTab";

/**
 * 
 * @param {props} anlagen array of anlagen objects
 * @param {props} selected object selected anlage
 * @param {props} setSelected setter of object anlage
 * 
 * @returns 
 */
const TimelineFilters = ({anlagen, selected, setSelected, tabData, setTabData}) => {

    const [selectedEnergy, setSelectedEnergy] = useState(['Strom', 'Gas', 'Strom-Einspeisung']);
    const [filteredAnlagen, setFilteredAnlagen] = useState([]);


    // initial
    useEffect(() => {
        if (anlagen) {
            setFilteredAnlagen(anlagen);
        }
    }, [anlagen])


    // if selected energy changes filter anlagen
    useEffect(() => {
        if (anlagen.length > 0) {
            if (selectedEnergy.length > 0) {
                var temp = anlagen.filter(a => selectedEnergy.includes(a.x_studio_field_3eKe0));
                setFilteredAnlagen(temp);
                if (temp.length > 0) {
                    setSelected(temp[0].id)
                } else {
                    setSelected(null);
                }
            } else {
                setFilteredAnlagen([]);
                setSelected(null);
            }
        }
    }, [selectedEnergy])


    // click handler on energy cards
    const clickEnergyHandler = (energy) => {
        if (selectedEnergy.includes(energy)) {
            setSelectedEnergy(selectedEnergy.filter(e => e !== energy));

        } else {
            setSelectedEnergy([...selectedEnergy, energy]);
        }
    }

    return (
        <>
            <Row className="justify-content-center">
                <Col xs="12" md="4" xl="4">
                        <EnergoTab data={tabData} setData={setTabData} />
                </Col>
            </Row>
            {anlagen !== undefined ?
                <Row className="justify-content-center mt-3" hidden={anlagen === undefined}>
                    <Col xs="12" xl="3">
                        <QuickAccessCard 
                            schema="energo"
                            icon={<SlEnergy size={35} />}
                            count={anlagen? anlagen.filter(a => a.x_studio_field_3eKe0 === "Strom").length: 0}
                            title="Stromanlagen"
                            isSelected={selectedEnergy.includes("Strom")}
                            handler={() => clickEnergyHandler("Strom")}
                        />
                    </Col>
                    <Col xs="12" xl="3">
                        <QuickAccessCard 
                            schema="info"
                            icon={<TbFlame size={35} />}
                            count={anlagen !== undefined? anlagen.filter(a => a.x_studio_field_3eKe0 === "Gas").length:0}
                            title="Gasanlagen"
                            isSelected={selectedEnergy.includes("Gas")}
                            handler={() => clickEnergyHandler("Gas")}
                        />
                    </Col>
                    <Col xs="12" xl="3">
                        <QuickAccessCard 
                            schema="warning"
                            icon={<MdOutlineSolarPower size={35}/>}
                            count={anlagen !== undefined? anlagen.filter(a => a.x_studio_field_3eKe0 === "Strom-Einspeisung").length:0}
                            title="Strom-Einspeisung"
                            isSelected={selectedEnergy.includes("Strom-Einspeisung")}
                            handler={() => clickEnergyHandler("Strom-Einspeisung")}
                        />
                    </Col>
                </Row>
            :null
            }
            <Row>
                <Col xs="12" lg="12">
                    <div className="scroll text-center">
                        {anlagen.length > 0 ? filteredAnlagen.map(anlage => (
                            <SmallAnlageCard key={anlage.id} id={anlage.x_studio_field_mWMGR} active={selected === anlage.id} selected={selected} setSelected={setSelected} anlage={anlage} />
                        )) : null}
                    </div>
                </Col>
            </Row>
        </>
    )
}

export default TimelineFilters;